$(document).ready(function() {
    /* Validate Login */
    $('#customer_login').validate({
        errorElement: "em",
        errorPlacement: function ( error, element ) {
            // Add the `invalid-feedback` class to the error element
            error.addClass( "invalid-feedback" );

            if ( element.prop( "type" ) === "checkbox" ) {
                error.insertAfter( element.next( "label" ) );
            } else {
                error.insertAfter( element );
            }
        },
        highlight: function ( element, errorClass, validClass ) {
            $( element ).addClass( "is-invalid" ).removeClass( "is-valid" );
        },
        unhighlight: function (element, errorClass, validClass) {
            $( element ).addClass( "is-valid" ).removeClass( "is-invalid" );
        }
    });

    /* Validate Sign-Up */
    $('#RegisterForm').validate({
        rules: {
            "customer[password]": {
                required: true,
                minlength: 8,
            }
        },
        errorElement: "em",
        errorPlacement: function ( error, element ) {
            // Add the `invalid-feedback` class to the error element
            error.addClass( "invalid-feedback" );

            if ( element.prop( "type" ) === "checkbox" ) {
                error.insertAfter( element.next( "label" ) );
            } else {
                error.insertAfter( element );
            }
        },
        highlight: function ( element, errorClass, validClass ) {
            $( element ).addClass( "is-invalid" ).removeClass( "is-valid" );
        },
        unhighlight: function (element, errorClass, validClass) {
            $( element ).addClass( "is-valid" ).removeClass( "is-invalid" );
        }
    });
    $('#register_submit').click(function(event){
        $(this).prop('disabled', true);
        $(this).html('<i class="fa fa-spinner fa-spin"></i> Wait...');
        var valid_test = $("#RegisterForm").valid();
        if (valid_test) {
            $('form#RegisterForm').submit();
        } else {
            $(this).html("Create");
            $(this).prop('disabled', false);
        }
    })

    $('.qtybox .btnqty').on('click', function(e) {
        e.preventDefault();
        var qty = parseInt($(this).parent('.qtybox').find('.quantity-input').val());
        if ($(this).hasClass('qtyplus')) {
            qty++;
        } else {
            if (qty > 1) {
                qty--;
            }
        }
        qty = (isNaN(qty)) ? 1 : qty;
        $(this).parent('.qtybox').find('.quantity-input').val(qty);
    });

    $('button.btn-blue').click(function(){
        window.location.href = "/account/register";
    });

    $('button.btn-white').click(function(){
        window.location.href = "/";
    });

});


$(document).ready(function() {async function updateLineItem(data) {
        await fetch(window.Shopify.routes.root + 'cart.js')
            .then(response => response.json())
            .then( async function(cart) {
                let itemKey = data.itemKey;
                let gramsWeight = data.gramsWeight;
                let gramsValue = data.gramsValue
                let lineItem = cart.items.filter(i => i.key == itemKey);

                let itemData = {
                    'id': itemKey,
                    'quantity': lineItem[0].quantity,
                    'properties': {
                        "Veteran allotment": gramsWeight,
                        "Dried flower equivalent": gramsValue,
                    }
                };
                await fetch(
                    window.Shopify.routes.root + 'cart/change.js', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify(itemData)

                    }).then(response => {
                    return data;
                }).catch((error) => {
                    console.error('Error:', error);
                });
            })
    }

    async function getItemMetaFieldValue(data) {
        let productId = "gid://shopify/Product/" + data.productId;
        let variantId = btoa("gid://shopify/ProductVariant/" + data.variantId);
        let isSimple = data.isSimple;
        let itemKey = data.itemKey;
        let productQuery;
        if (isSimple === true) {
            productQuery = () => `query {
            product(id: "${productId}") {
                id
                medical_allotment: metafield(namespace: "custom", key: "medical_allotment") {
                    value
                }
                grams_value: metafield(namespace: "custom", key: "grams_value") {
                    value
                }
            }
        }`;
        } else {
            productQuery = () => `
                query {
                  node(id:  "${variantId}") {
                    ... on ProductVariant {
                        id
                        medical_allotment: metafield(namespace: "custom", key: "medical_allotment") {
                            value
                        }
                        grams_value: metafield(namespace: "custom", key: "grams_value") {
                            value
                        }
                    }
                  }
                }
                `;
        }
        await fetch('/api/2024-04/graphql.json', {
            method: 'POST',
            headers: {
                'X-Shopify-Storefront-Access-Token': 'f2091b0cfb84abeabfdce7abcc2dfbde',
                'Content-Type': 'application/graphql'
            },
            body: productQuery()
        })
            .then(response => response.json() )
            .then( async function(res) {
                if (res.data) {
                   
                    let gramsWeight = 0;
                    let gramsValue = 0;

                    if (isSimple === true) {
                        if (res.data.product.medical_allotment !== null) {
                            if (res.data.product.medical_allotment.value !== null) {
                                gramsWeight = res.data.product.medical_allotment.value;
                            }
                        }
                        if (res.data.product.grams_value !== null) {
                            if (res.data.product.grams_value.value !== null) {
                                gramsValue = res.data.product.grams_value.value;
                            }
                        }
                    } else {
                        if (res.data.node !== null) {
                            if (res.data.node.medical_allotment !== null) {
                                if (res.data.node.medical_allotment.value !== null) {
                                    gramsWeight = res.data.node.medical_allotment.value;
                                }
                            }
                            if (res.data.node.grams_value !== null) {
                                if (res.data.node.grams_value.value !== null) {
                                    gramsValue = res.data.node.grams_value.value;
                                }
                            }
                        }
                    }

                    const data = {
                        itemKey: itemKey,
                        gramsWeight: gramsWeight,
                        gramsValue: gramsValue
                    };
                    
                    return data
                }
            })
            .then((data) => updateLineItem(data))
            .catch(err => console.error(err));
    }

      async function refreshMetaFields() {
        fetch(window.Shopify.routes.root + 'cart.js')
            .then(response => response.json())
            .then( async function(data) {
                let cart_items = data.items
                for await (const element of cart_items) {    
                    const pData = {
                        productId: element.product_id,
                        variantId: element.variant_id,
                        itemKey: element.key,
                        isSimple: element.product_has_only_default_variant
                    };
                    const metaData = await getItemMetaFieldValue(pData)
                }
                return cart_items.length
            })
            .then(async function(data) {
              refreshGrams();
            })
            .then(function(data) {
                var checkoutButton = document.getElementById('checkout');
                checkoutButton.innerHTML = 'Check out'
                checkoutButton.disabled = false;
                checkoutButton.style.display = "inline-block";
            })
            .catch(function (error) {
                console.log(error);
            });
    }

    async function refreshGrams() {
        await fetch(window.Shopify.routes.root + 'cart.js')
            .then(response => response.json())
            .then(data => {

                let cart_items = data.items
                let cart_grams_total = 0;
                let cart_grams_total_veteran = 0;
                let prescription_status = 0;
                let veteran_status = 0;
                var veteran_data = document.querySelector('#veteran_data');
                veteran_status = veteran_data !== null ? veteran_data.getAttribute('data-veteran') : 0;

                // Loop cart items to get Grams Value total
                cart_items.forEach(element => {
                  if(element.properties != null) {
                    
                    if (typeof element.properties['Grams Value'] != "undefined") {
                        var item_total_grams_value = element.quantity * element.properties['Grams Value']
                        cart_grams_total += item_total_grams_value;
                    }
                    if (typeof element.properties['Grams Weight'] != "undefined") {
                        var item_total_grams_value_vet = element.quantity * element.properties['Grams Weight']
                        cart_grams_total_veteran += item_total_grams_value_vet;
                    }
                    if (typeof element.properties['Dried flower equivalent'] != "undefined") {
                        var item_total_grams_value = element.quantity * element.properties['Dried flower equivalent']
                        cart_grams_total += item_total_grams_value;
                    }
                    if (typeof element.properties['Veteran allotment'] != "undefined") {
                        var item_total_grams_value_vet = element.quantity * element.properties['Veteran allotment']
                        cart_grams_total_veteran += item_total_grams_value_vet;
                    }
                    
                  }
                });

                cart_grams_total = Number(cart_grams_total).toFixed(2);
                cart_grams_total_veteran = Number(cart_grams_total_veteran).toFixed(2);
               
                // Update cart page
                if ($("#cart_grams_total")[0]) {
                    var el1 = document.querySelector('#cart_grams_total');
                    
                    if (veteran_status == '1') {
                      el1.setAttribute("data-cart-grams-total", cart_grams_total_veteran);
                      el1.innerText = cart_grams_total_veteran + "g";
                    } else {
                      el1.setAttribute("data-cart-grams-total", cart_grams_total);
                      el1.innerText = cart_grams_total + "g";
                    }
                    var el3 = document.querySelector('#prescription_data');
                    prescription_status = el3.getAttribute('data-status');
                }

                // Update header
                if ($("#site-header__total_grams")[0]) {
                    var el2 = document.querySelector('#site-header__total_grams');
                    if (veteran_status == 1) {
                      el2.setAttribute("data-cart-grams-total", cart_grams_total_veteran);
                      el2.innerText = cart_grams_total_veteran + "g";
                    } else {
                      el2.setAttribute("data-cart-grams-total", cart_grams_total);
                      el2.innerText = cart_grams_total + "g";
                    }
                }

                // Update cart.js Attributes

                let cartData = {
                    //'note': 'Total Cannabis: ' + Number(cart_grams_total).toFixed(2) + 'g, Total Cannabis (Veteran): ' + Number(cart_grams_total_veteran).toFixed(2) + 'g',
                    'attributes': {
                        "cart_grams_total": cart_grams_total,
                        "cart_grams_total_veteran": cart_grams_total_veteran,
                        "prescription_status": prescription_status
                    }
                };

                  fetch(
                    window.Shopify.routes.root + 'cart/update.js', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify(cartData)
                 }).then(response => {
                     return response.json();
                 }).catch((error) => {
                     console.error('Error:', error);
                 });

                 return data;
            }).then((data) => {
                // Grams count check
                if ($("#cart_grams_total")[0]) {
                    var validateCheckout = validateGrams();
                  
                    var errorGrams = document.getElementById("errorGrams");
                    if (validateCheckout && checkoutButton) {
                        checkoutButton.disabled = false;
                        checkoutButton.style.display = "inline-block";
                        if (errorGrams) {
                            errorGrams.style.display = "none";
                        }
                    } else {
                        
                        if (checkoutButton) {
                            
                            checkoutButton.style.display = "none";
                            checkoutButton.disabled = true;
                        }
                        if (errorGrams) {
                            errorGrams.style.display = "block";
                            var errorGramsCart = document.getElementById("cart-validate-grams");
                            errorGramsCart.classList.add("text-danger");
                        }
                    }
                    if (checkoutButton) {
                        checkoutButton.innerHTML = 'Check out'
                    }

                }
                return data.item_count;
            }).then((data) => {
                return data.item_count;
            }).catch(function (error) {
               console.log(error);
            });
    }

    var checkoutButton = document.getElementById('checkout');
    if (checkoutButton) {
        
        checkoutButton.style.display = "inline-block";
        checkoutButton.disabled = true;
        var waitMsg = '<i class="fa fa-spinner fa-spin"></i> Please Wait...';
        checkoutButton.innerHTML = waitMsg;
        refreshMetaFields();
    }

    document.addEventListener("addItemToCart", function(event) {
        refreshGrams();
    });

    document.addEventListener("qview-addedtocart", function(event) {
        
        const data = {
            productId:event.detail.product_id,
            variantId:event.detail.variant_id,
            itemKey:event.detail.key,
            isSimple:event.detail.product_has_only_default_variant
        };
        getItemMetaFieldValue(data);
        
    });

    document.addEventListener("qview-after-close", function(event) {
        refreshGrams();
    });

    document.addEventListener("updateItemQuantity", function(event) {
        refreshGrams();
    });

    document.addEventListener("onRemoveItem", function(event) {
        refreshGrams();
    });

    document.addEventListener("variantChange", function(event) {
        let variantID = event.detail.variant.id;
        let productData = document.querySelector("[data-variant-id=" + CSS.escape(variantID) + "]");
        if (productData) {
            let productDataGramsValue = productData.getAttribute('data-variant-grams-value');
            let productDataGramsWeight = productData.getAttribute('data-variant-medical_allotment');
            $('#current-variant-grams-value').val(productDataGramsValue);
            $('#current-variant-medical_allotment').val(productDataGramsWeight);
        }
    });


    /* Validate Cart Checkout */
    function validateGrams() {
        var el_cart_grams_total = document.getElementById('cart_grams_total');
        var el_cart_grams_available = document.getElementById('cart_grams_available');
        let dataTotal = el_cart_grams_total.getAttribute('data-cart-grams-total');
        let dataAvailable = el_cart_grams_available.getAttribute('data-cart-grams-available');
        return parseFloat(dataTotal) > parseFloat(dataAvailable) ? false : true;
    }

});

$(document).ready(function() {
      window.addEventListener("globoFilterCloseSearchCompleted", function(event) {
            document.querySelector('nav.mobile-nav-wrapper').classList.remove('is-transitioning');
            $(".search-bar__close.js-drawer-close").trigger("click");
      });
});